module.exports = __webpack_public_path__ + "media/images/theme/isc/favicon-019cc3dbfd505150593ec85f13823191.ico";